import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cetDate',
    standalone: false
})
export class CetDatePipe implements PipeTransform {
  private static readonly formatter = new Intl.DateTimeFormat('de-AT', {
    timeZone: 'Europe/Vienna',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  transform(value: string | Date | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    const date = value instanceof Date ? value : new Date(CetDatePipe.ensureUtc(value));
    if (isNaN(date.getTime())) {
      return '';
    }
    const parts = CetDatePipe.formatter.formatToParts(date);
    const get = (type: Intl.DateTimeFormatPartTypes): string =>
      parts.find((p) => p.type === type)?.value ?? '';
    return `${get('day')}.${get('month')}.${get('year')} ${get('hour')}:${get('minute')}:${get('second')}`;
  }

  private static ensureUtc(value: string): string {
    // Backend sends naive datetimes (USE_TZ=False) like "2026-04-19T12:38:39".
    // Without a tz suffix, browsers parse as local time, so we explicitly mark UTC.
    return /T\d/.test(value) && !/(Z|[+-]\d{2}:?\d{2})$/.test(value) ? value + 'Z' : value;
  }
}
